import { useEffect } from 'react';
import { formatClientName } from '../utils/formatNameHelper';
import { USER_TYPES } from '../constants/user';

const updateFavicon = (iconUrl) => {
  // Remove existing favicons
  const existingLinks = document.querySelectorAll("link[rel*='icon']");
  existingLinks.forEach((link) => link.remove());

  // Create new favicon link
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/x-icon';
  link.href = iconUrl;

  // Add error handling for favicon load failure
  link.onerror = () => {
    // Fallback
    link.href = '/favicon.jpeg';
  };

  document.head.appendChild(link);
};

export const usePageTitle = ({
  clientName,
  clientLogo,
  userType,
  title = 'Dashboard - Login',
}) => {
  useEffect(() => {
    const formattedClientName = formatClientName(clientName);

    document.title = formattedClientName
      ? `${formattedClientName} - Dashboard`
      : userType === USER_TYPES.superuser
        ? 'InfestSnap Dashboard'
        : title;

    const logo =
      clientLogo && userType !== USER_TYPES.superuser ? clientLogo : '/favicon.jpeg';

    updateFavicon(logo);
  }, [clientName, clientLogo, userType, title]);
};

export default usePageTitle;
